import React,{useEffect,useRef,useState}from"react";
import{useLocation,useNavigate}from"react-router-dom";
import{Document,Page,pdfjs}from"react-pdf";
import"react-pdf/dist/Page/AnnotationLayer.css";
import"react-pdf/dist/Page/TextLayer.css";
import"./caridoc-redesign.css";

pdfjs.GlobalWorkerOptions.workerSrc=`//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const ViewChapter=()=>{
 const navigate=useNavigate(),location=useLocation(),readerRef=useRef(null);
 const models=location.state?.models??[],initial=location.state?.index??0;
 const[currentIndex,setCurrentIndex]=useState(initial);
 const[isSubscribed,setIsSubscribed]=useState(false);
 const[numPages,setNumPages]=useState(0);
 const[pageWidth,setPageWidth]=useState(700);
 const[zoom,setZoom]=useState(1);
 const model=models[currentIndex];

 useEffect(()=>{const raw=localStorage.getItem("user");if(raw){try{setIsSubscribed(Boolean(JSON.parse(raw)?.subscription?.active))}catch(e){}}},[]);
 useEffect(()=>{const f=e=>{if((e.ctrlKey||e.metaKey)&&["s","p"].includes(e.key.toLowerCase()))e.preventDefault()};window.addEventListener("keydown",f);return()=>window.removeEventListener("keydown",f)},[]);
 useEffect(()=>{setNumPages(0);setZoom(1);window.scrollTo({top:0,behavior:"smooth"})},[currentIndex]);
 useEffect(()=>{const measure=()=>{const w=readerRef.current?.clientWidth||window.innerWidth;setPageWidth(Math.max(280,Math.min(820,w-24)))};measure();window.addEventListener("resize",measure);return()=>window.removeEventListener("resize",measure)},[]);

 if(!model)return <div className="caridoc-empty">Chapter not found. <button onClick={()=>navigate("/chapters")}>Back to Chapters</button></div>;

 const prev=()=>currentIndex>0&&setCurrentIndex(x=>x-1);
 const next=()=>{if(currentIndex>=models.length-1)return;if(!isSubscribed&&currentIndex>=2){alert("Please subscribe to unlock all chapters.");return}setCurrentIndex(x=>x+1)};
 const changeZoom=delta=>setZoom(z=>Math.min(2,Math.max(.75,Number((z+delta).toFixed(2)))));

 return <main className="caridoc-reader"><div className="caridoc-reader-inner">
  <button className="caridoc-back" onClick={()=>navigate("/chapters")}>← Chapters</button>
  <div className="caridoc-reader-toolbar"><div className="caridoc-reader-title"><small>CHAPTER {currentIndex+1} OF {models.length}</small><h1>{model.title}</h1></div>
   <div className="caridoc-reader-nav"><button disabled={currentIndex===0} onClick={prev}>← Previous</button><button disabled={currentIndex>=models.length-1} onClick={next}>Next →</button></div>
  </div>
  <div className="caridoc-pdf-controls" aria-label="PDF controls"><button onClick={()=>changeZoom(-.15)} disabled={zoom<=.75}>−</button><span>{Math.round(zoom*100)}%</span><button onClick={()=>changeZoom(.15)} disabled={zoom>=2}>+</button><button onClick={()=>setZoom(1)}>Fit</button></div>
  <div className="caridoc-document caridoc-pdf-reader" ref={readerRef} onContextMenu={e=>e.preventDefault()}>
   <Document file={model.fileUrl} onLoadSuccess={({numPages:n})=>setNumPages(n)} loading={<div className="caridoc-pdf-status">Loading chapter…</div>} error={<div className="caridoc-pdf-status"><strong>Chapter preview could not load.</strong><br/><a href={model.fileUrl} target="_blank" rel="noreferrer">Open PDF full screen</a></div>}>
    {Array.from({length:numPages},(_,i)=><Page key={i+1} pageNumber={i+1} width={pageWidth*zoom} renderAnnotationLayer={false} renderTextLayer={true}/>)}
   </Document>
  </div>
 </div></main>
};
export default ViewChapter;